import { NgComponentOutlet } from '@angular/common';
import { Component, input, Type } from '@angular/core';
import { SearchActivityItemComponent } from '@web/shared/components/search/items/search-activity-item.component';
import { SearchEntry } from '../types/search-entry.type';
import { SearchContactItemComponent } from './search-contact-item.component';
import { SearchDocumentAssetItemComponent } from './search-document-asset-item.component';
import { SearchEmployeeItemComponent } from './search-employee-item.component';
import { SearchNoteItemComponent } from './search-note-item.component';
import { SearchRealEstateItemComponent } from './search-real-estate-item.component';
import { SearchSupplierItemComponent } from './search-suppliers-item.component';
import { SearchTaskItemComponent } from './search-task-item.component';

@Component({
  selector: 'app-search-item',
  imports: [NgComponentOutlet],
  template: `@let _item = item();
    <ng-container *ngComponentOutlet="componentMap[_item.searchEntryKind]; inputs: { item: _item }"> </ng-container> `,
})
export class SearchItemComponent {
  readonly item = input.required<SearchEntry>();

  readonly componentMap: Record<SearchEntry['searchEntryKind'], Type<unknown>> = {
    contacts: SearchContactItemComponent,
    notes: SearchNoteItemComponent,
    activities: SearchActivityItemComponent,
    'real-estates': SearchRealEstateItemComponent,
    tasks: SearchTaskItemComponent,
    employees: SearchEmployeeItemComponent,
    suppliers: SearchSupplierItemComponent,
    'document-assets': SearchDocumentAssetItemComponent,
  };
}
